import { cn } from "@/utils/theme";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
  ScrollArea,
} from "@elaniintc/goes-design-system";
import { useState } from "react";
import { Operations } from "./operations";

import type { Operation, OperationSelectorProps } from "./types";

export const OperationSelector = ({
  selectedVariable,
  selectedOperation,
  onSelectOperation,
  group,
  disabled = false,
}: OperationSelectorProps) => {
  const [isOpen, setIsOpen] = useState(false);
  console.log(selectedVariable?.type);
  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="quiet"
          group={group}
          className="h-full text-body-loud min-w-0 max-w-1/2"
          disabled={disabled}
        >
          <p className="truncate">{selectedOperation?.label ?? "Acción"}</p>
          <Icon
            type="far"
            name="angle-down"
            className={cn(
              "transition-transform duration-200",
              isOpen ? "rotate-180" : "",
            )}
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        className="border-neutral h-full rounded-lg w-[280px]"
      >
        <ScrollArea className="h-[264px]">
          {selectedVariable?.type &&
            Operations[selectedVariable.type].map((operation) => (
              <DropdownMenuItem
                key={operation.name}
                className="text-body h-11 text-base"
                onClick={() => {
                  onSelectOperation(operation as Operation);
                  // console.log(operation)
                  setIsOpen(false);
                }}
              >
                {operation.label}
              </DropdownMenuItem>
            ))}
        </ScrollArea>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
